import { makeStyles } from "tss-react/mui";

import { TabList, TabListProps } from "@mui/lab";
import { Box } from "@mui/material";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles()((theme: Theme) => ({
    tabsContainer: {
        display: "flex",
        justifyContent: "center",
        marginBottom: theme.spacing(3),
        alignSelf: "center",
    },
    tabsList: {
        border: `1px solid ${theme.palette.emteria.border.primary}`,
        borderRadius: theme.spacing(1.5),
        padding: "2px",
        backgroundColor: theme.palette.emteria.background.paperDeep,
        minHeight: "auto",
        position: "relative",

        "& .MuiTabs-indicator": {
            top: 2,
            bottom: 2,
            height: "auto",
            borderRadius: theme.spacing(1),
            backgroundColor: theme.palette.background.paper,
            boxShadow: `inset 0 0 0 2px ${theme.palette.emteria.background.paperDeep}`,
            transition: "left 0.3s ease, width 0.3s ease",
        },
        "& .MuiTabs-flexContainer": {
            gap: "2px",
        },
        "& .MuiTab-root": {
            minHeight: "auto",
            padding: "0 12px",
            margin: 0,
            borderRadius: theme.spacing(1),
            color: theme.palette.emteria.text.secondary,
            gap: theme.spacing(1.5),
            zIndex: 1,
        },
        "& .MuiTab-root.Mui-selected": {
            color: theme.palette.text.primary,
        },
    },
}));

export const PageTabList = ({ children, ...props }: TabListProps) => {
    const { classes } = useStyles();
    return (
        <Box className={classes.tabsContainer}>
            <TabList {...props} className={classes.tabsList}>
                {children}
            </TabList>
        </Box>
    );
};
